import { useData } from "@providers/context";

export const userPermissionCheck = (permit: string | undefined): boolean => {
  const { permissionData } = useData();
  let newArray: any[] = [
    ...(permissionData?.permissions || ([] as [])),
    "dashboard",
    "wallet",
  ];
  if (newArray?.includes(permit)) {
    return true;
  }
  return false;
};

export const multiplePermissionCheck = (permits: any) => {
  const check = permits?.map((val: string) => userPermissionCheck(val));
  let result = false;

  for (let i = 0; i < check?.length; i++) {
    result = result || check[i];
    if (result === true) {
      break; // Short-circuit if result is already true
    }
  }

  return result;
};
